<template>
<v-card flat >
  <v-list class="pa-0" >
    <appointment-list-item
      :with-action=false v-if='appointment'
      :appointment='value' >
    </appointment-list-item>
  </v-list>
  <v-progress-linear
    v-if='appointmentDetailRequest.loading || actionStatus.loading'
    height='2' class='ma-0 pa-0' indeterminate >
  </v-progress-linear>
  <v-divider></v-divider>

  <!-- v-if="withPatientDetails" -->
  <v-window v-model="window" vertical touchless >

    <v-window-item >
      <v-tabs v-model='activeTab' >
        <v-tab >Create new</v-tab>
        <v-tab >Choose an existing client</v-tab>
        <v-tab v-if="withDependent" >Dependency details</v-tab>
        <v-tabs-items v-model='activeTab' >
          <v-tab-item >
            <v-card flat>
              <v-card-title class='subtitle-1 overline' >
                Create a new client
              </v-card-title>
              <v-card-text >
                <v-text-field
                  label="Full name"
                  v-model='fullname'
                  hint="The client's name and surname. e.g.: Jon Snow" >
                </v-text-field>
                <phone-number-input
                  :short-list='["ZA"]'
                  selected-country-code='ZA'
                  v-model='phone' >
                </phone-number-input>
                <v-text-field
                  label="Email"
                  type='email'
                  v-model='email'
                  hint='e-mail address. e.g.: jon@gmail.com' >
                </v-text-field>
              </v-card-text>
              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn :loading='actionRequest.loading' @click='set' color='primary' >Create and assign</v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item >
            <v-card>
              <v-card-title class='subtitle-1 overline' >
                Choose an existing client
              </v-card-title>
              <client-list
                v-if='!selectedclient'
                @relationshipselected='setSelected'
                :initial-text='fullname'
                :with-create='false'
                :with-action='false' >
              </client-list>
              <v-list v-else three-line >
                <client-list-item
                  v-if='selectedclient'
                  :relationship-id='selectedclient.id'
                  :client='selectedclient.client' >
                  <v-btn @click='set' :loading='actionRequest.loading' slot='action' color='primary' >
                    Set client
                  </v-btn>
                </client-list-item>
                <v-btn @click='selectedclient=null' flat small >
                  <v-icon small>chevron_left</v-icon>
                  Choose a different user</v-btn>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item >
            <v-card flat>
              <request-status :request='requests.dep' @ok="$emit('input', appointment)" />
              <v-alert tile :value="true" type="info" class="caption pa-1 ma-0" >
                You can set the patient information specifically for this appointment.
                Use this if the patient is different from the contact person (e.g.: a dependant)
                - this will only set the information on this appointment
              </v-alert>
              <v-card-text>
                <v-text-field label="Appointment title" v-model="appointment.title" />
                <v-text-field label="Patient full name"  v-model="appointment.full_name" />
                <!-- <v-text-field label="Patient full name" /> -->
              </v-card-text>
              <v-card-actions >
                <v-spacer />
                <v-btn @click="saveDependent" :loading="requests.dep.loading" color="primary" >Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-window-item >
    <v-window-item >
      <v-card flat class='text-center' >
        <center>
          <v-icon color='success' size='75' class='mt-4' >check_circle</v-icon>
          <br/>
          <blockquote class='blockquote mb-4' >Appointment updated</blockquote>
        </center>
        <v-card-actions >
          <v-btn flat text small @click='window=0' >Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat text small @click='window=0;$emit("close")' >Done</v-btn>
        </v-card-actions >
      </v-card>
    </v-window-item>
  </v-window>

</v-card>
</template>
<script>
import PhoneNumberInput from '@/components/PhoneNumberInput'
import ClientList from '@/components/client/ClientList'
import ClientListItem from '@/components/client/ClientListItem'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import {ACTIVE_APPOINTMENT_DETAIL} from '@/store/constants'

export default {
  name: 'SetClient',
  components: {
    PhoneNumberInput,
    ClientList,
    ClientListItem,
    AppointmentListItem
  },
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
    withDependent: { type: Boolean, default: false }
  },
  data () {
    return {
      window: 0,
      activeTab: 0,
      fullname: '',
      email: '',
      phone: '',
      selectedclient: null,
      actionRequest: {
        loading: false,
        status: 0,
        data: {}
      },
      requests: {
        dep: {
          resource: 'ag.appointments',
          resourceId: 0
        }
      },
      appointment: {
        title: '',
        full_name: ''
      },
      showSetDependent: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.appointment = this.value
          this.title = this.appointment.title
          this.fullname = this.appointment.full_name
          this.email = this.appointment.contact_email
          this.phone = this.appointment.contact_phone

          if (this.appointment.id && !this.appointment.contact_email) {
            this.get(this.appointment.id)
          }
        }
      }
    },
    touch () {
      this.selectedclient = null
      this.activeTab = 0
      this.window = 0
    },
    appointmentDetailRequestStatus () {
      if (this.appointmentDetailRequestStatus === 200) {
        this.appointment = this.remoteAppointment
        this.fullname = this.appointment.full_name
        this.email = this.appointment.contact_email
        this.phone = this.appointment.contact_phone
      }
    },
    actionStatus () {
      if (this.actionStatus === 200) {
        // this.activeTab = 2
        this.window = 1
        this.getAppointment(this.appointment.id)
        this.getClients()
        this.getAppointmentsInRange()
      }
    }
  },
  computed: {
    appointmentDetailRequest () {
      return this.$store.getters.getRequestById(ACTIVE_APPOINTMENT_DETAIL, true)
    },
    appointmentDetailRequestStatus () {
      return this.appointmentDetailRequest.status
    },
    actionStatus () {
      return this.actionRequest.status
    },
    remoteAppointment () {
      return this.getObjectPath(this.appointmentDetailRequest, 'result.data', {})
    },
    payload () {
      let setNewClient = (this.activeTab === 0)
      if (setNewClient) {
        return {
          'full_name': this.fullname,
          'email': this.email,
          'phone_number': this.phone
        }
      } else {
        if (this.selectedclient) {
          return {
            'relationship_id': this.selectedclient.id
          }
        }
      }
    }
  },
  methods: {
    setSelected (client) {
      this.selectedclient = client
    },
    get (appointmentId) {
      this.getAppointment(appointmentId)
    },
    set () {
      this.action(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        this.appointment.id,
        'set_client',
        this.payload,
        this.actionRequest
      )
    },
    saveDependent () {
      this.requests.dep.resourceId = this.appointment.id
      this.requests.dep.data = {
        full_name: this.appointment.full_name,
        title: this.appointment.title
      }
      this.$request('save', this.requests.dep)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SetClient.vue?ea8578fa